function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background-color: #e1e8ef;\n  height: 35px;\n  border-radius: 4px;\n  padding-left: 7px;\n  padding-right: 16px;\n  justify-content: space-around;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  appearance: none;\n  border: none;\n  padding: 0;\n  background-color: transparent;\n  width: 42px;\n  height: 27px;\n  border-radius: 6px;\n  background-color: ",
        ";\n  font-size: 12px;\n  font-weight: bold;\n  color: ",
        ";\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Flex } from '@dutchie/common/components/rebass-compat';
import styled from 'styled-components';
var ButtonGroup = function(param) {
    var options = param.options, selectedOption = param.selectedOption, onSelect = param.onSelect, onDeselect = param.onDeselect;
    return /*#__PURE__*/ _jsx(ButtonContainer, {
        children: options.map(function(option) {
            return /*#__PURE__*/ _jsx(Option, {
                onClick: function() {
                    if (selectedOption === option.value) {
                        onDeselect(option.value);
                    } else {
                        onSelect(option.value);
                    }
                },
                selected: selectedOption && selectedOption === option.value,
                children: option.label
            }, option.label);
        })
    });
};
ButtonGroup.testProps = [
    {
        options: [
            {
                value: 'someVal',
                label: 'Hey Look'
            },
            {
                value: 'otherVal',
                label: "Hey Don't Look"
            }
        ]
    }
];
export default ButtonGroup;
var ButtonContainer = styled(Flex)(_templateObject());
var Option = styled.button(_templateObject1(), function(props) {
    return props.selected ? '#f8fbff' : 'transparent';
}, function(props) {
    return props.selected ? '#4597e0' : '#69829f';
});
